import { lsPost, safeAwait } from 'utils/request'

export const decryptText = ({ type, cipherText }) => {
  return safeAwait(lsPost(`/system/decrypt`, { type, cipherText }))
}
